var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFleetLfTcollapseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F622E2E2-A449-4D92-B2AA-CEC73B423AAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup-6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fleet--DashBoard-Search",
    transform: "translate(-306.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(0.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(316.000000, 35.000000) scale(-1, 1) translate(-316.000000, -35.000000) translate(306.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#00142D",
    transform: "translate(10.409091, 9.500000) rotate(-270.000000) translate(-10.409091, -9.500000) ",
    points: "10.4090909 6 15.8181818 13 5 13"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFleetLfTcollapseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fleet_LFTcollapse_icon.59f699588d1d43d9cd12bcd606242c45.svg";